import { BadRequestErrorModel, ConflictErrorModel, EntityError, StatusCode } from './api.types';
import {
  LOCALSTORAGE_ACTIVE_SUPPLIER,
  LOCALSTORAGE_SUPPLIERS,
  LOCALSTORAGE_TOKEN_FIELD,
  LOCALSTORAGE_USER_FIELD
} from '../types/app.index';
import { showErrorToast } from '../components/Toaster';

const mapEntityTypeToHumanReadable: { [ key: string ]: string } = {
  promoCode: 'Promo code',
  stopSell: 'Stop sell',
  carModel: 'Car model',
  product: 'Product',
  brokerRate: 'Broker rate',
  item: 'Item',
  classifier: 'Classifier',
  classifierType: 'ClassifierType',
  itemPrice: 'Item Price',
  broker: 'Broker'
};

const parseBadRequestErrorMessage = (field: string, message: string) => `${field}: ${message}`;

const handleBadRequest = (errorObject: BadRequestErrorModel | EntityError) => {
  if (errorObject instanceof EntityError) {
    showErrorToast(parseBadRequestErrorMessage(errorObject.entity, errorObject.message));
  } else {
    errorObject.rows.forEach((row) => showErrorToast(parseBadRequestErrorMessage(row.field, row.message)));
  }
};

const parseOtherErrorMessage = (statusCode: StatusCode, errorObject: ConflictErrorModel, apiMethodType: string) => {
  let msg = 'Error!';
  if (statusCode === StatusCode.CONFLICT) {
    if (apiMethodType === 'delete') {
      msg = `${mapEntityTypeToHumanReadable[ errorObject.entity ]} with "${errorObject.criteria[0].field}" ${errorObject.criteria[0].value} is in use`;
    } else {
      msg = `${mapEntityTypeToHumanReadable[ errorObject.entity ]} with  "${errorObject.criteria[0].field}" ${errorObject.criteria[0].value} already exists`;
    }
  }
  return msg;
};

const errorResponseHandler = async (error: any, renewRequest: any) => {
  if (error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false) {
    return Promise.reject(error);
  }
  const url = error.config.url;
  const user = localStorage.getItem(LOCALSTORAGE_USER_FIELD);
  if (error.response) {
    if (error.response.status === StatusCode.UNAUTHORIZED) {
      window.location.replace('/login');
      localStorage.removeItem(LOCALSTORAGE_TOKEN_FIELD);
      localStorage.removeItem(LOCALSTORAGE_USER_FIELD);
      localStorage.removeItem(LOCALSTORAGE_ACTIVE_SUPPLIER);
      localStorage.removeItem(LOCALSTORAGE_SUPPLIERS);

    } else if (error.response.status === StatusCode.SESSION_EXPIRED) {
      localStorage.removeItem(LOCALSTORAGE_TOKEN_FIELD);
      localStorage.removeItem(LOCALSTORAGE_USER_FIELD);
      localStorage.removeItem(LOCALSTORAGE_ACTIVE_SUPPLIER);
      localStorage.removeItem(LOCALSTORAGE_SUPPLIERS);
      window.location.replace('/login');

    } else if (error.response.status === StatusCode.NOT_FOUND) {
      window.location.replace('/404');

    } else if (error.response.status === StatusCode.INVALID_PERMISSIONS) {
      window.location.replace('/invalidpermissions');

    } else if (error.response.status === StatusCode.BAD_REQUEST) {
      if (error.response.data.entity) {
        handleBadRequest(new EntityError(error.response.data.message, error.response.data.entity));
      } else {
        handleBadRequest(error.response.data);
      }
    } else {
      showErrorToast(parseOtherErrorMessage(error.response.status, error.response.data, error.response.config.method));
    }
  }

  return Promise.reject(error);
};


export default errorResponseHandler;
